import { CreateLinkDto, Link, UpdateLinkDto } from '@klubovna/api-client';
import { LinksQueryParams } from '@adminServices';
import { createAction, props } from '@ngrx/store';

export const ADMIN_LINKS_ID = '[Links admin]';

export const loadLinks = createAction(
  ADMIN_LINKS_ID + ' Load Links',
  props<{ params?: LinksQueryParams }>(),
);

export const loadLinksSuccess = createAction(
  ADMIN_LINKS_ID + ' Load Links Success',
  props<{ links: Link[]; pagination: { total: number; page: number; limit: number; totalPages: number } }>(),
);

export const loadLinksFailure = createAction(
  ADMIN_LINKS_ID + ' Load Links Failure',
  props<{ error: string }>(),
);

export const createLink = createAction(
  ADMIN_LINKS_ID + ' Create Link',
  props<{ linkData: CreateLinkDto }>(),
);

export const createLinkSuccess = createAction(
  ADMIN_LINKS_ID + ' Create Link Success',
  props<{ link: Link }>(),
);

export const createLinkFailure = createAction(
  ADMIN_LINKS_ID + ' Create Link Failure',
  props<{ error: string }>(),
);

export const updateLink = createAction(
  ADMIN_LINKS_ID + ' Update Link',
  props<{ id: string; linkData: UpdateLinkDto }>(),
);

export const updateLinkSuccess = createAction(
  ADMIN_LINKS_ID + ' Update Link Success',
  props<{ link: Link }>(),
);

export const updateLinkFailure = createAction(
  ADMIN_LINKS_ID + ' Update Link Failure',
  props<{ error: string }>(),
);

export const deleteLink = createAction(
  ADMIN_LINKS_ID + ' Delete Link',
  props<{ id: string }>(),
);

export const deleteLinkSuccess = createAction(
  ADMIN_LINKS_ID + ' Delete Link Success',
  props<{ id: string }>(),
);

export const deleteLinkFailure = createAction(
  ADMIN_LINKS_ID + ' Delete Link Failure',
  props<{ error: string }>(),
);

export const uploadImage = createAction(
  ADMIN_LINKS_ID + ' Upload Image',
  props<{ id: string; file: File }>(),
);

export const uploadImageSuccess = createAction(
  ADMIN_LINKS_ID + ' Upload Image Success',
  props<{ link: Link }>(),
);

export const uploadImageFailure = createAction(
  ADMIN_LINKS_ID + ' Upload Image Failure',
  props<{ error: string }>(),
);

export const deleteImage = createAction(
  ADMIN_LINKS_ID + ' Delete Image',
  props<{ id: string }>(),
);

export const deleteImageSuccess = createAction(
  ADMIN_LINKS_ID + ' Delete Image Success',
  props<{ link: Link }>(),
);

export const deleteImageFailure = createAction(
  ADMIN_LINKS_ID + ' Delete Image Failure',
  props<{ error: string }>(),
);
